import React from 'react';
import {
  SinglePageHeader,
  FooterWithoutAuth,
  BlogCard,
  Layout,
} from 'components';
import './packages-and-payment-page.less';

import './blog.less';
import marketingImg from 'assests/images/mesajussu-nasil-calisir.png';
import blogBannerAccessory1 from 'assests/images/pap-accessory-1.png';
import blogBannerAccessory2 from 'assests/images/features-accessory-3.png';
import { LANDING_MENU } from 'constants/page.const';
import { MetaTags } from 'react-meta-tags';

const HowItWorksPage = () => {
 
  return (
    <Layout
      hamburgerMenuWithButton={true}
      hamburgerMenuData={LANDING_MENU}
      hamburgerMenuClass="single-page-v1"
      withoutHeaderDropdown={true}
      withoutCreditInfo={true}
      menuSinglePageV2={true}
      customMenuRender={() => <SinglePageHeader />}
    >
      <MetaTags> 
    <title>Turkcell Mesaj Üssü Üye Olma ve Kullanma Kılavuzu</title>
            <meta name="description" content="Turkcell Mesaj Üssü programına nasıl üye olunacağını ve nasıl kullanılacağını öğrenmek için tıklayın!" />
            <link
          rel="canonical"
          href="https://mesajussu.turkcell.com.tr/nasil-calisir"
        />
          </MetaTags>
      <div className="blog-page blog-page--marketing">
        <div className="blog-banner">
          <div className='container'>
            <div>
              <h1 className="section__title--big">
              Mesaj &Uuml;ss&uuml; Nasıl &Ccedil;alışır?
              </h1>
              <p className="info-text--big">
              Turkcell Mesaj Üssü programına nasıl üye olunacağını ve nasıl kullanılacağını öğrenmek için tıklayın!
              </p>
            </div>
            <figure>
            <a href="/toplu-sms">
              <img src={marketingImg} alt="Mesaj Üssü Nasıl Çalışır?" />
            </a>
            </figure>
          </div>
          <img
            id="blog-banner-accessory-1"
            src={blogBannerAccessory1}
            alt="Mesaj Üssü Nasıl Çalışır? 2"
          />
          <img
            id="blog-banner-accessory-2"
            src={blogBannerAccessory2}
            alt="Mesaj Üssü Nasıl Çalışır? 3"
          />
        </div>
        <div className="blogs-wrapper">
          <div className="container">
          <ul>
<li><h2>Nasıl &Uuml;ye Olurum?</h2>Turkcell Mesaj &Uuml;ss&uuml; &uuml;yeliğinizi başlatmak i&ccedil;in, Turkcell telefon numaranızla giriş yapmanız yeterli. Daha sonra telefonunuza gelen tek kullanımlık şifreyi girerek, şifre değiştirme işleminizi yaptıktan sonra kurumsal hatlarınız i&ccedil;in şirket adınızla mesaj başlığı talebinde bulunabilirsiniz.</li>
<li><h2>Mesaj Başlığı Almak İ&ccedil;in Ne Yapmam Gerekiyor?</h2> Mesaj başlığı almak i&ccedil;in Turkcell Mesaj &Uuml;ss&uuml; Taahh&uuml;tnamesini sistemden online olarak onaylamanız gereklidir. Online olarak imzaladığınız taahh&uuml;tname sisteme girdiğiniz mail adresinize ayrıca g&ouml;nderilir ve sistemlerimizde 10 sene s&uuml;reyle saklanır. Kendi isminizle mesaj g&ouml;ndermek isterseniz, size &ouml;nerilen mesaj başlıklarından birini se&ccedil;ip, &ouml;n &ouml;demeli paketlerimizden birini alarak mesaj g&ouml;ndermeye anında başlayabilirsiniz! Şirket ya da marka adınızla mesaj g&ouml;ndermek isterseniz yine Mesaj &Uuml;ss&uuml;'ne vergi levhası, ticari faaliyet belgesi ve imza sirk&uuml;lerini y&uuml;kleyerek marka adınızla da mesaj başlığı talebinde bulunabilirsiniz. Eğer şirketiniz daha &ouml;nceden Turkcell sistemlerinde kayıtlı ise, Vergi Numaranızı girdiğinizde; belge y&uuml;klemenize gerek kalmadan otomatik olarak m&uuml;şteri temsilcilerimiz sistemde kayıtlı olan belgelerinizi inceleyecektir. Eğer şirketinizi Turkcell&rsquo;e ilk kez kayıt ettiriyorsanız, y&uuml;klediğiniz belgeleriniz bize ulaştıktan sonra tek yapmanız gerek &ouml;n &ouml;demeli paketlerden birini se&ccedil;mek ve Turkcell g&uuml;vencesiyle m&uuml;şterilerinize ister Toplu SMS ister Turkcell Zengin İ&ccedil;erikli Mesaj g&ouml;ndererek satışlarınızı katlamak!</li>
<li><h2>Nasıl Paket Satın Alırım?</h2> Turkcell Mesaj &Uuml;ss&uuml; aboneliğinizi başlattıktan sonra, kredi kartınızla &ouml;n &ouml;demeli paketlerimizden birini 3D secure &ouml;demeyle kolayca satın alabilirsiniz. Aldığınız &ouml;n &ouml;demeli paketin bedelini, giriş yaptığınız Turkcell telefon numaranıza ait faturanızda da ayrıca g&ouml;rebilirsiniz. Kredileriniz mesafeli satış s&ouml;zleşmesini onaylayarak, alım işlemini tamamladığınız anda hesabınıza tanımlanır ve hemen kullanmaya başlayabilirsiniz. İsterseniz kredi kartınızı Turkcell&rsquo;e kayıt ettirerek, Turkcell&rsquo;den yapacağınız bir sonraki alışverişinizde telefon numaranızla otomatik olarak eşlenmiş kredi kartınızı kolaylıkla kullanabilirsiniz. Aldığınız pakete dair &ouml;deme bilgileri daha sonra SMS yoluyla size bildirilir.</li>
<li><h2>Nasıl Mesaj G&ouml;nderirim?</h2> Mesaj başlığınızı aldıktan sonra tek yapmanız gereken, m&uuml;şteri numaralarınızı excel ya da .txt dosyasıyla sisteme y&uuml;klemek ya da isterseniz tek tek girerek numaralarınızı girerek rehberinizi oluşturmak. Daha sonra isterseniz Toplu SMS, mesajlarınızın daha renkli ve dikkat &ccedil;ekici olmasını isterseniz de ZİM g&ouml;ndererek kampanya ve duyurularınızı m&uuml;şterilerinizle paylaşabilirsiniz. ZİM'inizi kendiniz tasarlamak isterseniz, firma logonuz, kampanya g&ouml;rseliniz gibi g&ouml;rselleri de ekleyerek yine Mesaj &Uuml;ss&uuml; i&ccedil;erisinden kendi ZİM'inizi oluşturabilirsiniz.</li>
<li><h2>M&uuml;şterilerim SMS G&ouml;nderimlerinden &Ccedil;ıkmak İsterse Ne olacak?</h2> Turkcell Mesaj &Uuml;ss&uuml;, Elektronik Ticaret Kanunu kapsamında mesaj g&ouml;nderilen kişilere sunmak zorunda olduğunuz SMS g&ouml;nderimlerinden &ccedil;ıkma hakkını sizin i&ccedil;in her SMS'in sonuna konulacak &uuml;cretsiz kısa numara ile sağlar. Mesaj başlığınıza &ouml;zel oluşturulacak anahtar kelime her mesajın sonuna eklenir ve m&uuml;şterileriniz bu kısa numaraya mesaj atarak g&ouml;nderimlerden &ccedil;ıkabilirler. Bu m&uuml;şteriler daha sonra size raporlanarak, yaptığınız g&ouml;nderimlerden &ccedil;ıkarılır. Mesaj &Uuml;ss&uuml; sizi Elektronik Ticaret Kanunu kapsamında uymanız gereken kurallar konusunda da ayrıca y&ouml;nlendirirken, siz sadece mesajlarınıza odaklanabilirsiniz.</li>
<li><h2>Size Nasıl Ulaşırım?</h2> Herhangi bir konuda yardıma ihtiya&ccedil; duyduğunuzda Mesaj &Uuml;ss&uuml; i&ccedil;erisindeki 'Bize Ulaşın' sekmesinden bize yardıma ihtiya&ccedil; duyduğunuz konu hakkında yazabilirsiniz. Dilerseniz 532'yi arayarak da bize ulaşabilirsiniz.</li>
</ul>
        </div>
      </div>
      </div>
      <FooterWithoutAuth />
    </Layout>
  );
};

export default HowItWorksPage;
